/**
 * BrandMark — unified ElementPad icon used in the header, footer, and anywhere
 * the brand needs to render inline. Source of truth is /public/favicon.svg
 * (same artwork shipped as the favicon, apple-touch-icon, manifest icon, and
 * og-image), so every surface stays in lockstep.
 *
 * We render the rasterized 192px PNG instead of the SVG to avoid font-rendering
 * drift across browsers (the SVG falls back to system fonts in the favicon
 * slot; here we want the typeset master).
 */
export default function BrandMark({
  size = 24,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <img
      src="/favicon-192.png"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      decoding="async"
      loading="eager"
      className={className}
      style={{ borderRadius: size * 0.22 }}
    />
  );
}